import {ScreenShareView} from './ScreenShareView';
import {useState, type ReactNode} from 'react';
import {Maximize2, Minimize2} from 'lucide-react';
import type {Participant} from 'livekit-client';
import './screen-shares.css';

export function ScreenShares({screens, expanded, onExpand, onCollapse, renderScreen, children}: {
  screens: Participant[]; expanded: boolean; onExpand:()=>void; onCollapse:()=>void;
  renderScreen:(participant:Participant)=>ReactNode; children?:ReactNode;
}) {
  const [selected,setSelected]=useState('');
  const current=screens.find(person=>person.identity===selected) || screens[0];
  if(!current)return null;
  const name=(person:Participant)=>person.name || 'Участник';
  return <div className={`call-screens screen-shares${expanded?' screen-shares--focused':''}`}>
    {expanded&&<div className="screen-shares-toolbar">
      <div className="screen-shares-choices" role="group" aria-label="Чей экран смотреть">
        {screens.map(person=><button type="button" key={person.identity} aria-pressed={current.identity===person.identity} onClick={()=>setSelected(person.identity)} title={name(person)}>{name(person)}</button>)}
      </div>
      <button type="button" className="screen-shares-collapse" aria-label="Вернуть все экраны" onClick={onCollapse}><Minimize2 size={21}/><span>Свернуть</span></button>
    </div>}
    <div className="screen-shares-stage">
      {screens.map(person=><div key={person.identity} className="screen-shares-item" hidden={expanded&&current.identity!==person.identity} data-screen-owner={person.identity}>
        <ScreenShareView>{renderScreen(person)}</ScreenShareView>
        {!expanded&&<button type="button" className="screen-shares-expand" aria-label={`Развернуть экран: ${name(person)}`} onClick={()=>{setSelected(person.identity);onExpand();}}><Maximize2 size={21}/><span>На весь экран</span></button>}
      </div>)}
    </div>
    {!expanded&&children}
  </div>;
}
